var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.563 2.688A.56.56 0 0 0 7 2.125a.56.56 0 0 0-.562.563v3.75h-3.75A.56.56 0 0 0 2.125 7c0 .312.25.563.563.563h3.75v3.75a.561.561 0 1 0 1.125 0v-3.75h3.75c.311 0 .562-.251.562-.563a.56.56 0 0 0-.562-.562h-3.75z"
  })));
};
export default SvgAdd;